<kt-portlet>
  <!-- PORTLET LOADING | Binded to TABLE Datasource -->
  <!-- See prop => '~/core/_crud/models/data-sources/_base.datasource.ts' (loading$) -->
  <kt-portlet-header
    title="{{ 'TABLE.RELATIONSHIP_LIST' | translate }}"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddRelation">
          <button
            type="button"
            (click)="addRel()"
            mat-raised-button
            color="primary"
            matTooltip="Create new relationship"
            [disabled]="isSwitchedToEditMode"
          >
            <span class="svg-icon-md" translate="CONTACT_RELATIONSHIP.NEW_CONTACT_RELATIONSHIP">
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              New Relationship
            </span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <!-- start::Body (attribute: ktPortletBody) -->
  <kt-portlet-body>
    <!-- start::FILTERS & GROUP ACTIONS -->

    <!-- end::FILTERS & GROUP ACTIONS -->
    <div class="row align-items-center">
      <div class="col-md-2 kt-margin-bottom-10-mobile">
        <mat-form-field class="mat-form-field-fluid" appearance="fill">
          <mat-label>{{ 'GLOBAL.ENTITY_TYPE' | translate }}</mat-label>
          <mat-select
            [(value)]="filterStatus"
            (selectionChange)="loadRelsList()"
            placeholder="{{ 'GLOBAL.ENTITY_TYPE' | translate }}"
          >
            <mat-option value="">{{ 'GLOBAL.ALL' | translate }}</mat-option>
            <mat-option value="DOCTOR"><span translate="ENTITY.DOCTOR">Doctor</span></mat-option>
            <mat-option value="PATIENT"><span translate="ENTITY.PATIENT">Patient</span></mat-option>
            <mat-option value="FACILITY"
              ><span translate="ENTITY.FACILITY">Facility</span></mat-option
            >
          </mat-select>
          <mat-hint align="start">
            <strong>{{ 'GLOBAL.FILTER' | translate }}</strong>
            {{ 'GLOBAL.BY_ENTITY_TYPE' | translate }}
          </mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <form>
        <mat-table
          class="lmat-elevation-z8"
          [dataSource]="dataSource"
          #sort="matSort"
          matSort
          multiTemplateDataRows
          matSortActive="name"
          matSortDirection="asc"
          matSortDisableClear
        >
          <ng-container matColumnDef="name">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="mat-column"
              translate="CONTACT_RELATIONSHIP.TABLE.NAME"
              >Name
            </mat-header-cell>
            <mat-cell *matCellDef="let relationship" class="mat-column gl-block">
              <span>{{ getFullName(relationship) }}</span>
              <i
                *ngIf="relationship.is_prime"
                class="flaticon2-correct text-success icon-md ml-2"
              ></i>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="relationType.category.entityType">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >Type
            </mat-header-cell>
            <mat-cell *matCellDef="let relationship" class="mat-column">
              {{ relationship.entity_type }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="relationType.category.name">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column"
              >Category
            </mat-header-cell>
            <mat-cell *matCellDef="let relationship" class="mat-column">
              {{ relationship.relation_type }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="relationType.descriptionType">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="mat-column"
              translate="CONTACT_RELATIONSHIP.TABLE.DESCRIPTION"
            >
              Description
            </mat-header-cell>
            <mat-cell *matCellDef="let relationship" class="mat-column">
              <mat-form-field
                *ngIf="relationship._isEditMode"
                class="mat-form-field-fluid"
                appearance="fill"
              >
                <mat-label translate="CONTACT_RELATIONSHIP.FORM.DESCRIPTION">Description</mat-label>
                <input matInput formControlName="editDescription" />
              </mat-form-field>
              <span *ngIf="!relationship._isEditMode">{{
                relationship.relationship_description
              }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="classification">
            <mat-header-cell
              *matHeaderCellDef
              class="mat-column"
              translate="CONTACT_RELATIONSHIP.TABLE.CLASSIFICATION"
            >
              Classification
            </mat-header-cell>
            <mat-cell *matCellDef="let relationship" class="mat-column">
              <span
                class="svg-icon svg-icon-md svg-icon-success cursor-pointer"
                style="display: flex; height: 30px"
              >
                <span
                  class="m-1"
                  style="display: flex; align-items: center"
                  *ngIf="relationship.financial_responsible"
                  matTooltip="Financial Responsible"
                  inlineSVG="./assets/media/svg/icons/General/dollar.svg"
                ></span>
                <span
                  class="m-1"
                  style="display: flex; align-items: center"
                  *ngIf="relationship.emergency_contact"
                  matTooltip="Emergency Contact"
                  inlineSVG="./assets/media/svg/icons/General/siren.svg"
                ></span>
                <span
                  class="m-1"
                  style="display: flex; align-items: center"
                  *ngIf="relationship.phi_authorized"
                  matTooltip="PHI Authorized"
                  inlineSVG="./assets/media/svg/icons/General/hipaa_seal.svg"
                ></span>
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef class="mat-column-actions" translate="TABLE.ACTIONS">
              Actions
            </mat-header-cell>
            <mat-cell *matCellDef="let rel" class="mat-column-actions">
              <ng-template ngxPermissionsOnly="canEditRelation">
                <button
                  *ngIf="!rel._isEditMode"
                  type="button"
                  mat-icon-button
                  color="primary"
                  [disabled]="getViewAgreementsButtonState(rel).disabled === true"
                  (click)="viewAgreementsButtonOnClick(rel)"
                  class="margin-2"
                  matTooltip="View Agreements"
                >
                  <span class="svg-icon svg-icon-md svg-icon-primary">
                    <span inlineSVG="./assets/media/svg/icons/General/Clipboard.svg"></span>
                  </span>
                </button>
              </ng-template>
              <ng-template ngxPermissionsOnly="canEditRelation">
                <button
                  *ngIf="!rel._isEditMode"
                  [disabled]="isSwitchedToEditMode"
                  type="button"
                  mat-icon-button
                  color="primary"
                  (click)="editRelationshipButtonOnClick(rel)"
                  class="margin-2"
                  matTooltip="Edit Relationship"
                >
                  <span class="svg-icon svg-icon-md svg-icon-primary">
                    <span inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"></span>
                  </span>
                </button>
              </ng-template>
              <ng-template ngxPermissionsOnly="canDeleteRelation">
                <button
                  *ngIf="!rel._isEditMode"
                  [disabled]="isSwitchedToEditMode"
                  mat-icon-button
                  color="warn"
                  type="button"
                  (click)="deleteRel(rel)"
                  class="margin-2"
                  matTooltip="Delete Relationship"
                >
                  <span class="svg-icon svg-icon-md svg-icon-danger">
                    <span inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"></span>
                  </span>
                </button>
              </ng-template>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </form>
      <div
        class="mat-table__message"
        *ngIf="
          contactRelationshipsResult.length == 0 &&
          !loading &&
          !(dataSource.isPreloadTextViewed$ | async)
        "
      >
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <!-- Message for empty data  -->
      <div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom" hidden>
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
    <!-- end: BOTTOM -->
  </kt-portlet-body>
  <!-- end::Body -->
</kt-portlet>
